// extracted by mini-css-extract-plugin
export default {"body":"alias-email-entry_body__rLl8h","loading":"alias-email-entry_loading__Yxgip"};